import angular from 'angular';
import LmiAirtableProposedLending from './lmiAirtableProposedLending';

export default angular
  .module('components.lmiAirtableProposedLending', [])
  .component('lmiAirtableProposedLending', LmiAirtableProposedLending).name;
